import React from 'react';
import PropTypes from 'prop-types';
import RpTable from 'rp-react-table';
import columns from './columns';

const BigRaceWins = ({ data, type }) => (
    <div className="mp-bigRaceWins">
        <RpTable
            data={data}
            columns={columns(type)}
            initialSortIdx={0}
            noDataText="No big race wins"
            resultsPerPage={50}
        />
    </div>
);

BigRaceWins.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        raceDate: PropTypes.string,
        raceInstanceTitle: PropTypes.string,
        horseStyleName: PropTypes.string,
        jockeyStyleName: PropTypes.string,
        prizeSterling: PropTypes.number,
        trainerStyleName: PropTypes.string,
    })),
    type: PropTypes.string.isRequired,
};

export default BigRaceWins;



// WEBPACK FOOTER //
// ./src/js/human/stats/bigRaceWins/BigRaceWins.jsx